import { inject, Pipe, PipeTransform } from '@angular/core';
import { ClimateEntriesQueries } from '../../states/climateEntries/climate-entries.queries';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClimateCalculationService } from '../services/climate-calculation.service';
import { Accommodation } from '../../core/swagger/models/accommodation';

@Pipe({
  name: 'climateCalculationAccommodation',
  standalone: true,
})
export class ClimateCalculationAccommodationPipe implements PipeTransform {
  private readonly climateCalculationKeysQueries: ClimateEntriesQueries =
    inject(ClimateEntriesQueries);

  public transform(accommodation: Accommodation): Observable<number> {
    return this.climateCalculationKeysQueries.climateCalculationKeys$.pipe(
      map((climateCalculationKeys) =>
        climateCalculationKeys
          ? ClimateCalculationService.calculateAccommodations(
              [accommodation],
              climateCalculationKeys,
            )
          : 0,
      ),
    );
  }
}
